var map = {
	"./cameras.json": 39,
	"./commands.json": 40,
	"./fade.json": 41,
	"./forces.json": 42,
	"./hitbox.json": 43,
	"./images.json": 44,
	"./inputs.json": 45,
	"./opacity.json": 46,
	"./position.json": 47,
	"./previous.json": 48,
	"./state.json": 49,
	"./text.json": 50,
	"./timeout.json": 51,
	"./velocity.json": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;